import {Theme, createStyles} from '@material-ui/core';

export const moreArrowLinkStyles = (theme: Theme) =>
	createStyles({
		'@keyframes bounce': {
			'0%': {
				transform: 'translateX(0)',
			},
			'60%': {
				transform: `translateX(${theme.spacing(-2)}px)`,
			},
		},
		root: {
			cursor: 'pointer',
			display: 'inline-block',
			paddingLeft: theme.spacing(6),

			'& .MuiIconButton-label': {
				transform: 'translateX(0)',
				transition: 'all',
				transitionTimingFunction: 'ease-out',
				transitionDuration: `${theme.transitions.duration.standard}ms`,

				'&::before': {
					display: 'block',
					content: '" "',
					backgroundColor: theme.palette.primary.main,
					position: 'absolute',
					width: theme.spacing(9),
					height: 2,
					left: theme.spacing(-1 * 7),
					transition: 'left',
					transitionTimingFunction: 'ease',
					transitionDuration: `${theme.transitions.duration.standard}ms`,
				},
			},
			'&:hover': {
				'& .MuiIconButton-label': {
					animationName: '$bounce',
					animationDuration: `${theme.transitions.duration.standard * 5}ms`,
					animationIterationCount: 'infinite',

					'&::before': {
						left: theme.spacing(-1 * 8.5),
					},
				},
			},
		},
		button: {
			transition: 'background-color',
			transitionDuration: `${theme.transitions.duration.standard}ms`,
			backgroundColor: theme.palette.secondary.main,
			color: theme.palette.primary.main,

			'&:hover': {
				backgroundColor: theme.palette.secondary.dark,
			},
			'&:active': {
				backgroundColor: theme.palette.secondary.light,
			},
			'&.-is-small': {
				'&::before': {
					width: theme.spacing(7),
				},
			},
		},
	});
